<template>
  <div class="ordersEditScreen">
    <ProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') === -1"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></ProductModal>

    <PredefinedProductModal
      v-if="showModal && selectedProductID.indexOf('PRE_') >= 0"
      :productID="selectedProductID"
      :editData="selectedProductData"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showModal = false"
    ></PredefinedProductModal>

    <FreeTextProductModal
      :editData="selectedProductData"
      v-if="showFreeArticleModal"
      @addProduct="addProduct"
      @editProduct="editProduct"
      @hidden="showFreeArticleModal = false"
    ></FreeTextProductModal>

    <SubtitleModal
      :editData="selectedProductData"
      v-if="showSubtitleModal"
      @addSubtitle="addSubtitle"
      @editSubtitle="editSubtitle"
      @hidden="showSubtitleModal = false"
    ></SubtitleModal>

    <b-container variant="primary" fluid class="p-5">
      <b-row>
        <b-col :cols="12">
          <h3>Nuevo albarán</h3>

          <b-form @submit.stop.prevent="onSubmit">
            <b-alert :show="form.error.show" variant="danger">{{
              form.error.text
            }}</b-alert>

            <b-form-row class="mt-3">
              <b-col cols="12">
                <b-form-group
                  class="mb-0"
                  id="input-location"
                  label="Tienda destino"
                  description="Tienda donde está previsto entregar los pedidos"
                  label-for="location"
                >
                  <b-form-select
                    class="col-3"
                    :disabled="id !== 'new'"
                    :options="locationSelect.loadedOptions"
                    id="location"
                    v-model="$v.form.location.$model"
                    :state="validateState('location')"
                    aria-describedby="input-location-feedback"
                  ></b-form-select>

                  <b-form-invalid-feedback id="input-location-feedback"
                    >Este campo es obligatorio.</b-form-invalid-feedback
                  >
                </b-form-group>
              </b-col>

              <b-col class="mt-3" cols="12">
                <h4>Estado del albarán</h4>
              </b-col>
              <b-col cols="12">
                <b-form-radio-group
                  @change="changedStatus"
                  id="radio-group-1"
                  v-model="selectedStatus"
                  name="radio-options"
                >
                  <b-row no-gutters>
                    <b-col
                      class="orderStatusBox"
                      :class="{ active: selectedStatus === elem.status }"
                      v-for="(elem, i) in deliveryStatusHistoriesFmt"
                      :key="i"
                    >
                      <b-row>
                        <b-col cols="auto">
                          <div>
                            <h6>{{ elem.status | formatStatus }}</h6>
                            <span>{{ elem.date ? elem.date : '-' }}</span>
                          </div>
                        </b-col>
                        <b-col align-self="center" class="text-right">
                          <b-form-radio
                            :disabled="disableStatusRadioBtn(i)"
                            :value="elem.status"
                          >
                          </b-form-radio>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                </b-form-radio-group>
              </b-col>
            </b-form-row>

            <b-form-row class="mt-3">
              <b-col cols="12">
                <h4>Pedidos</h4>
              </b-col>
              <b-col :cols="12">
                <v-server-table
                  :url="getTableURI"
                  ref="table"
                  :columns="table.columns"
                  :options="table.options"
                >
                  <div slot="h__checkbox">
                    <b-form-checkbox
                      v-model="table.allSelected"
                      @change="toggleAll"
                    />
                  </div>

                  <div slot="checkbox" slot-scope="props">
                    <b-form-checkbox
                      :disabled="!enableCheckbox(props.row).status"
                      :checked="table.selected.includes(props.row.id)"
                      @change="toggleCell($event, props.row.id)"
                    />
                  </div>

                  <template v-slot:preview="props">
                    <img
                      style="max-height: 100px; max-width: 100px"
                      :src="props.row.image"
                    />
                  </template>

                  <template v-slot:type="props">
                    {{
                      props.row.quote === null && !props.row.is_web_sale
                        ? 'Pedido stock'
                        : 'Pedido venta'
                    }}
                  </template>

                  <template v-slot:more_info="props">
                    <div v-if="!enableCheckbox(props.row).status">
                      <span v-if="true">
                        {{ enableCheckbox(props.row).msg }}
                      </span>

                      <span v-else-if="props.row.delivery">
                        No seleccionable (ya incluído en albarán
                        {{ props.row.delivery.id }})
                      </span>
                      <span
                        v-else-if="
                          props.row.quote &&
                          props.row.quote.shipping_method_full &&
                          ![1, 2].includes(
                            props.row.quote.shipping_method_full.id
                          )
                        "
                      >
                        No seleccionable (presupuesto #{{
                          props.row.quote.id
                        }}
                        con {{ props.row.quote.shipping_method_full.name }} a
                        {{ props.row.quote.shipping_address_full.city }},
                        {{ props.row.quote.shipping_address_full.country }})
                      </span>

                      <span
                        v-else-if="
                          props.row.quote &&
                          props.row.quote.shipping_method_full &&
                          [1, 2].includes(
                            props.row.quote.shipping_method_full.id
                          ) &&
                          form.location &&
                          form.location !==
                            props.row.quote.shipping_method_full.id
                        "
                      >
                        No seleccionable (presupuesto #{{ props.row.quote.id }}
                        tiene
                        {{ props.row.quote.shipping_method_full.name }} pero
                        albarán con destino
                        {{
                          locationSelect.loadedOptions.find(
                            (x) => x.id === location
                          ).text
                        }})
                      </span>

                      <span v-else>-</span>
                    </div>
                    <div v-else>-</div>
                  </template>

                  <template v-slot:status="props">
                    <span
                      v-if="props.row.quote !== null || props.row.is_web_sale"
                      >{{ props.row.status | formatStatusWorkshopOrder }}</span
                    >
                    <span v-else>-</span>
                  </template>

                  <template v-slot:abbr_product_names="props">
                    <!-- Status finished: show content for stock workshop orders from content -->

                    <div
                      v-if="
                        props.row.quote === null &&
                        !props.row.is_web_sale &&
                        ['Finished', 'Sent', 'Delivered'].includes(
                          selectedStatus
                        )
                      "
                    >
                      <div
                        :key="product.id"
                        v-for="product in getProductsOfThisOrder(
                          props.row.delivery.content,
                          props.row.id
                        )"
                      >
                        {{ getAbbrProductName(product) }}
                      </div>
                    </div>

                    <div v-else>
                      <div
                        :key="i"
                        v-for="(abbr_product_name, i) in props.row
                          .abbr_product_names"
                      >
                        <div v-if="props.row.product_deliveries.length == 0">
                          {{
                            abbr_product_name['qty'] +
                            ' x ' +
                            abbr_product_name['name']
                          }}
                        </div>

                        <div
                          :class="{
                            'text-danger':
                              props.row.product_status[i] !== 'Finished',
                            'text-success':
                              props.row.product_status[i] === 'Finished',
                          }"
                          v-else-if="props.row.product_deliveries[i] < 0"
                        >
                          {{
                            abbr_product_name['qty'] +
                            ' x ' +
                            abbr_product_name['name']
                          }}
                        </div>
                      </div>
                    </div>
                  </template>

                  <template v-slot:origin="props">
                    <span>{{
                      props.row.order_id
                        ? 'Venta #' + props.row.order_id
                        : 'Stock'
                    }}</span>
                  </template>

                  <template v-slot:code_hex="props">
                    <span>#{{ props.row.code_hex }}</span>
                  </template>
                </v-server-table></b-col
              >

              <!-- <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  @click="addArticleToQuoteBtn"
                  >Añadir a pedido</b-button
                >
              </b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  @click="addFreeTextArticleToQuoteBtn"
                  >Añadir línea libre</b-button
                >
              </b-col>

              <b-col cols="2">
                <b-button
                  variant="outline-primary"
                  block
                  @click="addSubtitleToQuoteBtn"
                  >Añadir subtítulo (grupos)</b-button
                >
              </b-col> -->
            </b-form-row>

            <b-form-row class="mt-2">
              <b-col :cols="12">
                <b-row>
                  <b-col cols="12">
                    <b-button
                      variant="outline-primary"
                      :disabled="table.selected.length == 0"
                      block
                      type="submit"
                    >
                      {{
                        id !== 'new'
                          ? 'Guardar albarán'
                          : 'Guardar nuevo albarán'
                      }}</b-button
                    >
                  </b-col>

                  <!-- <b-col cols="auto">
                    <b-button
                      block
                      @click="markAsPaidShopSale()"
                      variant="outline-primary"
                    >
                      {{
                        this.id !== 'new'
                          ? 'Guardar pedido y generar pedido (venta en tienda)'
                          : 'Guardar pedido y generar pedido (venta en tienda)'
                      }}</b-button
                    >

                    <small class="gray-text"
                      >Guardará el pedido y generará un nuevo pedido
                      (marcado como pagado y entregado)</small
                    >
                  </b-col> -->
                </b-row>
              </b-col>
            </b-form-row>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { uris, actions } from '@/admin/api.js';

import {
  required,
  numeric,
  minValue,
  decimal,
  requiredIf,
} from 'vuelidate/lib/validators';
import ProductModal from '@/admin/components/quotes/ProductModal.vue';
import PredefinedProductModal from '@/admin/components/quotes/PredefinedProductModal.vue';

import FreeTextProductModal from '@/admin/components/quotes/FreeTextProductModal.vue';
import SubtitleModal from '@/admin/components/quotes/SubtitleModal.vue';

import store from '@/admin/store.js';
import { validationMixin } from 'vuelidate';

import * as Sentry from '@sentry/browser';
import Multiselect from 'vue-multiselect';

export default {
  name: 'AdminDeliveriesEditScreen',
  props: ['id'],

  components: {
    Multiselect,
    ProductModal,
    PredefinedProductModal,
    FreeTextProductModal,

    SubtitleModal,
  },
  mixins: [validationMixin],
  validations() {
    let rules = {
      // billingAddress: {
      //   required,
      // },

      location: {
        required,
      },
      workshop_orders: {
        $each: { required },
      },
    };

    return {
      form: rules,
    };
  },
  data() {
    let form = {
      workshop_orders: [],
      location: null,

      // password: '',
      // password_confirmation: '',
      error: {
        show: false,
        text: '',
      },
    };

    return {
      table: {
        // url: this.getTableURI || uris.deliveriesQualifiedWorkshopOrdersURI,
        selected: [],
        allSelected: false,
        filterable: false,
        columns: [
          'checkbox',
          'id',
          'abbr_product_names',
          'employee_full_name',
          'type',
          'status',
          'more_info',
        ],
        options: {
          // cellClasses: {
          //   status: [
          //     {
          //       class: 'bg-light-warning',
          //       condition: (row) => row.status === 'Finished',
          //     },
          //   ],
          // },

          sortable: ['modified_at', 'created_at'],
          headings: {
            status: 'Estado',
            type: 'Tipo',
            abbr_product_names: 'Productos',
            modified_at: 'Modificado',
            created_at: 'Creado',

            id: '# Pedido de taller',
            employee_full_name: 'Creado por',
            more_info: 'Más información',
          },
        },
      },
      hola: 1,
      sharedState: store.state,
      languageCodes: store.getLanguageCodes().filter((x) => x == 'es'),
      languageNames: store.getLanguageNames(),
      form: form,

      productsMultiselect: {
        loadedOptions: [],
        isLoading: false,
      },

      locationSelect: {
        loadedOptions: [],
      },

      discountTypeSelect: {
        options: [
          { text: 'Global', value: 'Total' },
          { text: 'Por producto', value: 'Per-product' },
        ],
      },
      selectedProductID: null,
      selectedProductData: null,
      showModal: false,
      showFreeArticleModal: false,
      showSubtitleModal: false,
      selectedStatus: null,
      deliveryStatusHistories: [],
    };
  },
  computed: {
    getTableURI() {
      if (this.id === 'new') {
        // new
        return uris.deliveriesQualifiedWorkshopOrdersURI;
      } else if (this.selectedStatus === 'Draft') {
        // edit AND is draft status
        return uris.deliveriesQualifiedWorkshopOrdersURI;
      } else {
        // edit AND is not draft status
        return uris.deliveriesWorkshopOrdersURI(this.id);
      }
    },
    deliveryStatusHistoriesFmt() {
      let arr = [];

      // Recogida en tienda (BAR, MAD)

      arr.push({ status: 'Draft', date: null });
      arr.push({ status: 'Finished', date: null });
      arr.push({ status: 'Sent', date: null });
      arr.push({ status: 'Delivered', date: null });

      this.deliveryStatusHistories.map((x) => {
        let elem = arr.find((y) => y.status === x.status);
        if (elem) {
          elem['date'] = x.created_at;
        }
      });
      return arr;
    },
    pendingAmt() {
      return (
        this.totalPrice -
        parseFloat(this.form.amtPaidCredit ? this.form.amtPaidCredit : '0.00') -
        parseFloat(
          this.form.amtPaidTransfer ? this.form.amtPaidTransfer : '0.00'
        ) -
        parseFloat(this.form.amtPaidCash ? this.form.amtPaidCash : '0.00')
      );
    },
    totalPrice() {
      return (
        parseFloat(this.form.totalPriceProductsInclTax) -
        parseFloat(this.form.discount) +
        parseFloat(this.form.shippingPrice)
      );
    },
  },
  created() {
    // this.productsMultiselect.isLoading = true;

    let promises = [];
    promises.push(actions.getLocationsUnpaginated());

    Promise.all(promises).then((x) => {
      // Location
      this.locationSelect.loadedOptions = x[0].data.results.map((x) => {
        return {
          text: x.name,
          value: x.id,
        };
      });
    });

    if (this.id !== 'new') {
      actions
        .getDeliveryStatusHistoriesByDelivery(this.id)
        .then((response6) => {
          this.deliveryStatusHistories = response6.data.results;
        });

      actions.getDelivery(this.id).then((response2) => {
        const data = response2.data;

        this.selectedStatus = data.status;

        this.table.selected = data.workshop_orders;

        this.form.workshop_orders = data.workshop_orders;

        this.form.location = data.location;
      });
    } else {
      this.selectedStatus = 'Draft';
    }
  },
  filters: {
    formatStatusWorkshopOrder: function (value) {
      return {
        Received: 'Recibido',
        Workshop: 'En taller',
        Finished: 'Terminado',
      }[value];
    },
    formatStatus: function (value) {
      return {
        Draft: 'Borrador',
        Finished: 'Terminado',
        Sent: 'Enviado',
        Delivered: 'Entregado',
      }[value];
    },
  },
  methods: {
    getProductsOfThisOrder(p, orderId) {
      let prod = [];
      for (let index = 0; index < p.workshop_orders.length; index++) {
        const element = p.workshop_orders[index];

        if (element === orderId) {
          prod.push(p.products[index]);
        }
      }
      return prod;
    },
    getAbbrProductName(p) {
      let w = [];
      p.reference.split(' ').forEach((word) => {
        w.push(word.slice(0, 3));
      });

      return ` ${p.quantity} x ${w.join(' ')} `;
    },
    enableCheckbox: function (rowData) {
      let ret = { status: true, msg: '' };

      // Disable checkboxes if delivery state is Finished, Sent or Delivered
      if (['Finished', 'Sent', 'Delivered'].includes(this.selectedStatus)) {
        ret['status'] = false;
        ret['msg'] = '';
        return ret;
      }

      // Disable if the stock order do not have any finished product
      if (
        rowData.quote === null &&
        !rowData.is_web_sale &&
        !rowData.product_status.some(
          (x, i) => x === 'Finished' && rowData.product_deliveries[i] <= 0
        )
      ) {
        ret['status'] = false;
        ret['msg'] =
          'Pedido no seleccionable (no tiene ningún producto con estado terminado).';
        return ret;
      }

      // Disable if the order is not with status Finished
      if (
        (rowData.quote !== null || rowData.is_web_sale) &&
        rowData.status !== 'Finished'
      ) {
        ret['status'] = false;
        ret['msg'] = 'Pedido no seleccionable (no está acabado).';
        return ret;
      }

      // Stock order assigned to another delivery?
      if (
        rowData.delivery &&
        this.id.toString() !== rowData.delivery.id.toString() &&
        rowData.delivery.status === 'Draft'
      ) {
        ret['status'] = false;
        ret[
          'msg'
        ] = `Pedido ya asignado al albarán ${rowData.delivery.id} con estado Borrador (considera desasignarlo o unificar albaranes).`;
        return ret;
      }

      // Not to be picked-up in store?
      if (
        rowData.quote &&
        rowData.quote.shipping_method_full &&
        ![1, 2].includes(rowData.quote.shipping_method_full.id)
      ) {
        ret['status'] = false;
        ret['msg'] = 'Pedido no seleccionable (no es para recoger en tienda).';
        return ret;
      }

      // Different location from quote vs delivery
      if (
        rowData.quote &&
        rowData.quote.shipping_method_full &&
        [1, 2].includes(rowData.quote.shipping_method_full.id) &&
        this.form.location !== rowData.quote.shipping_method_full.id
      ) {
        ret['status'] = false;
        ret['msg'] =
          'Pedido no seleccionable (tienda destino del albarán no coincide con la tienda donde se recogerá el pedido).';
        return ret;
      }

      return ret;
    },

    disableStatusRadioBtn(i) {
      return (
        this.deliveryStatusHistoriesFmt[i].date !== null ||
        (i > 0 && this.deliveryStatusHistoriesFmt[i - 1].date === null)
      );
    },
    changedStatusLogic() {
      if (this.selectedStatus === 'Finished') {
        // Check if any unfinished workshop orders inside this delivery. If so, do not continue.

        if (
          !confirm(
            'Al pasar el albarán a finalizado, se incluirán todos los productos terminados de los pedidos de stock marcados. Además, no será posible añadir más productos al albarán. ¿Deseas continuar?'
          )
        ) {
          this.selectedStatus = 'Draft';
          return false;
        }

        // console.log();
        // let workshopsFinishedCount = this.$refs.table.data.filter(
        //   (x) => this.table.selected.includes(x.id) && x.status === 'Finished'
        // ).length;

        // let selectedWorkshopsCount = this.table.selected.length;

        // if (workshopsFinishedCount !== selectedWorkshopsCount) {
        //   alert(
        //     'No es posible marcar el albarán como terminado si parte de sus pedidos de taller aún no están acabados'
        //   );
        //   this.selectedStatus = 'Draft';
        //   return false;
        // }
      }

      if (this.selectedStatus === 'Delivered') {
        if (
          !confirm(
            'Al pasar el albarán a entregado, estás declarando que has comprobado que los productos y unidades contenidas en él corresponden con el contenido teórico del albarán.\n\nAdemás, las unidades de todos aquellos pedidos de taller contenidos en este albarán que no formen parte de ninguna venta, se añadirán al stock existente de la tienda destino. ¿Deseas continuar?'
          )
        ) {
          this.selectedStatus = 'Sent';
          return false;
        }
      }

      let data = {};

      data['status'] = this.selectedStatus;

      if (this.id !== 'new') {
        actions.patchDelivery(this.id, data).then((x) => {
          this.currentDeadlineDate = x.data.deadline_workshop;

          actions
            .getDeliveryStatusHistoriesByDelivery(this.id)
            .then((response6) => {
              this.deliveryStatusHistories = response6.data.results;

              this.$refs.table.refresh();
            });
        });
      }
    },
    changedStatus() {
      this.changedStatusLogic(); // does not matter, BE will not send
      // }
    },

    swapProducts(i, j) {
      this.form.products[i] = this.form.products.splice(
        j,
        1,
        this.form.products[i]
      )[0];
      this.form.productPricesInclTax[i] = this.form.productPricesInclTax.splice(
        j,
        1,
        this.form.productPricesInclTax[i]
      )[0];
      this.form.productPricesExclTax[i] = this.form.productPricesExclTax.splice(
        j,
        1,
        this.form.productPricesExclTax[i]
      )[0];

      this.form.productHashes[i] = this.form.productHashes.splice(
        j,
        1,
        this.form.productHashes[i]
      )[0];

      this.form.productStocks[i] = this.form.productStocks.splice(
        j,
        1,
        this.form.productStocks[i]
      )[0];

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts[i] = this.form.productDiscounts.splice(
          j,
          1,
          this.form.productDiscounts[i]
        )[0];

        this.form.productDiscountsAbsolute[
          i
        ] = this.form.productDiscountsAbsolute.splice(
          j,
          1,
          this.form.productDiscountsAbsolute[i]
        )[0];
      }
    },
    moveUp(i) {
      i = parseInt(i);
      this.swapProducts(i, i - 1);
    },
    moveDown(i) {
      i = parseInt(i);
      this.swapProducts(i, i + 1);
    },

    setDecimal(name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form[name].$model = val;
      this.$v.form[name].$touch();
    },
    setDecimalProduct(i, name, val) {
      val = val.replace('.', ''); // remove thousands
      val = val.replace(',', '.'); // replace comma by dot
      this.$v.form.products.$each.$iter[i][name].$model = val;
      this.$v.form.products.$each.$iter[i][name].$touch();
      this.updateStock();
    },

    newCustomerModal() {},

    changedDiscount() {
      if (!this.form.shippingMethod) {
        return false;
      }
      this.updateStock();
    },
    updateStock() {
      let data = {};

      data['products'] = this.form.products;

      data['discount_pct'] = this.form.discountPct;

      data['product_discounts'] = this.form.productDiscounts;

      actions.postWorkshopOrderGetStock(data).then((x) => {
        // if (onlyUpdateDiscount) {
        //   this.form.discount = x.data.discount;
        //   this.form.taxPrice = x.data.taxPrice;
        // } else
        this.form.productPricesInclTax = x.data.productPricesInclTax;
        this.form.productPricesExclTax = x.data.productPricesExclTax;
        this.form.productDiscountsAbsolute = x.data.productDiscountsAbsolute;

        this.form.discount = x.data.discount;

        this.form.totalPriceProductsInclTax = x.data.totalPriceProductsInclTax;

        this.form.totalPriceProductsExclTax = x.data.totalPriceProductsExclTax;

        this.form.taxPrice = x.data.taxPrice;

        this.form.productHashes = x.data.productHashes;
        this.form.productStocks = x.data.productStockAvailability;
      });
    },
    cancelAddProduct() {
      this.showModal = false;
    },
    editSubtitle(subtitle) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        subtitle: subtitle,
        type: 'subtitle',
      });

      this.showSubtitleModal = false;
    },
    editProduct(productData, attributes, currentPrice, qty, comments, images) {
      const editedArticleIndex = this.articleCurrentIndex;

      this.form.products.splice(editedArticleIndex, 1, {
        reference: productData.reference,
        // attributes: attributes.map((x, i) => {
        //   return {
        //     name: x.label,
        //     txtValue: x.selector_inputs.name,
        //     value: x.selector_inputs.value,
        //   };
        // }),
        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.updateStock();

      this.showFreeArticleModal = false;

      this.showModal = false;
    },
    addSubtitle(subtitle) {
      this.showSubtitleModal = false;

      this.form.products.push({
        subtitle: subtitle,
        type: 'subtitle',
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.updateStock();
    },
    addProduct(productData, attributes, currentPrice, qty, comments, images) {
      this.showModal = false;
      this.showFreeArticleModal = false;

      if (this.form.discountType === 'Per-product') {
        this.form.productDiscounts.push('0');
        this.form.productDiscountsAbsolute.push('0');
      }

      this.form.products.push({
        reference: productData.reference,

        attributes: attributes.map(function (item) {
          delete item.selector_options;

          if (item.reference === 'BORDADO') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'INICIALES') {
            delete item.extra_info.color_options;
          }

          if (item.reference === 'TELA') {
            delete item.extra_info.fabricsInfo;
          }

          if ('initial_value' in item) {
            delete item.initial_value;
          }

          return item;
        }),
        quantity: qty,
        type: productData.type,
        price: currentPrice,
        id: productData.id,
        description: productData.type === 'free' ? productData.description : '',
        comments: comments,
        images: images,
      });

      // this.form.discountPct = this.form.customer.default_discount;

      this.updateStock();
    },
    deleteArticle(articleIndex) {
      const name = this.form.products[articleIndex].reference;

      if (
        confirm(
          '¿Estás seguro que deseas quitar el producto ' + name + ' del pedido?'
        )
      ) {
        this.form.products.splice(articleIndex, 1);
        this.updateStock();
      }
    },
    editArticle(articleIndex) {
      //if ()
      this.selectedProductID = this.form.products[articleIndex].id.toString();

      if (this.form.products[articleIndex].type === 'predefined') {
        this.selectedProductID = 'PRE_' + this.selectedProductID;
      }

      this.selectedProductData = this.form.products[articleIndex];
      this.articleCurrentIndex = articleIndex;

      if (this.selectedProductID === '0') {
        this.showFreeArticleModal = true;
      } else {
        this.showModal = true;
      }
    },

    addFreeTextArticleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showFreeArticleModal = true;
    },
    addSubtitleToQuoteBtn() {
      this.selectedProductID = null;
      this.selectedProductData = null;

      this.showSubtitleModal = true;
    },
    addArticleToQuoteBtn() {
      this.selectedProductID = this.form.product.value.toString();

      this.selectedProductData = null;

      this.showModal = true;
    },
    discountTypeChanged(val) {
      if (val === 'Per-product') {
        let arr = [];
        for (let index = 0; index < this.form.products.length; index++) {
          arr.push('0');
        }

        this.form.productDiscounts = arr;
        this.form.productDiscountsAbsolute = arr;

        this.form.discountPct = '0';
        this.form.discount = 0;
      } else {
        this.form.discountPct = '0';
        this.form.discount = 0;
      }
    },

    billingAddressSelectChanged(val) {
      actions.getBillingAddress(val).then((z) => {
        this.billingAddressSelect.selectedAddress = z.data;
      });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    validateStateProduct(index, field) {
      const { $dirty, $error } = this.$v.form.products.$each[index][field];
      return $dirty ? !$error : null;
    },
    getFormData() {
      let data = {};

      data['workshop_orders'] = this.table.selected;

      data['status'] = this.selectedStatus;

      data['location'] = this.form.location;

      return data;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      store.setOverlayShow(true);

      let data = this.getFormData();

      Sentry.setExtra('data', JSON.stringify(data));

      if (this.id !== 'new') {
        actions.patchDelivery(this.id, data).then((x) => {
          this.$router.push({ name: 'AdminDeliveriesScreen' });
        });
      } else {
        actions.postDelivery(data).then((x) => {
          this.$router.push({ name: 'AdminDeliveriesScreen' });
        });
      }
    },
    removeSelected() {
      this.table.selected.map((x) => {
        this.removeCustomer(x);
      });
    },
    removeCustomer(id) {
      actions.deleteCustomer(id).then((x) => {
        this.$refs.table.refresh();
      });
    },
    toggleCell($event, id) {
      if (!['Draft'].includes(this.selectedStatus)) {
        alert(
          'No puedes quitar o incluir nuevos pedidos en el albarán cuando ya ha sido finalizado. Por favor, refresca la página.'
        );
        return;
      }

      if ($event) {
        this.table.selected.push(id);
      } else {
        this.table.selected = this.table.selected.filter((item) => item !== id);
      }
    },
    toggleAll(checked) {
      if (!['Draft'].includes(this.selectedStatus)) {
        alert(
          'No puedes quitar o incluir nuevos pedidos en el albarán cuando ya ha sido finalizado. Por favor, refresca la página.'
        );
        return;
      }

      let arr = [];

      if (checked) {
        for (let index = 0; index < this.$refs.table.data.length; index++) {
          const element = this.$refs.table.data[index];
          if (!this.enableCheckbox(element)) {
          } else {
            arr.push(element.id);
          }
        }
      }

      this.table.selected = arr;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
::v-deep .bg-light-warning {
  background-color: rgba(184, 248, 110, 0.425) !important;
  &:hover {
    background-color: rgba(184, 248, 110, 0.733) !important;
  }
}
.subtitle {
  background-color: #f3f3f3;
  border: lightgray 1px solid;
  border-radius: 0.25rem;
  padding: 0.5rem;
  text-align: center;
}
.uniqueImg {
  display: block;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
}
.leftImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 0;
  left: 0;
}
.rightImg {
  display: block;
  max-width: 80%;
  max-height: 80%;
  width: auto;
  height: auto;
  position: absolute;
  top: 2rem;
  left: 2rem;
}

.comments {
  margin-top: 0.2rem;
  font-style: italic;
}

.gray-text {
  display: block;
  color: gray;
}

.stock {
  white-space: pre-wrap;
  &.available {
    color: green;
  }
  &.unavailable {
    color: red;
  }
}

ol {
  list-style-type: circle;
  li {
    margin-left: 2rem;
  }
}
</style>
